var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-container p-3 col-12 col-md-10 border mb-4" },
    [
      _c("div", [
        _c("span", { staticClass: "add-on" }, [
          _vm._v(_vm._s(this.translatedText)),
        ]),
        _c("br"),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            _vm._s(_vm._f("trans")("Get more Credits for premium tasks."))
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "price" }, [
        !this.unitPrice
          ? _c("span", { staticClass: "w-100 d-flex pl-4" }, [
              _c("span", {
                staticClass:
                  "spin-circle-basic spin-circle-225 spin-circle-medium",
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        this.unitPrice
          ? _c("span", [
              _c("span", { staticClass: "font-weight-bold add-on" }, [
                _vm._v(_vm._s(this.unitPrice)),
              ]),
              _vm._v(" " + _vm._s(this.translatedUnit)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "span",
          {
            staticClass: "btn btn-lg btn-app-color",
            on: { click: this.openPaymentModal },
          },
          [
            _vm._v(_vm._s(_vm._f("trans")("Buy Credits")) + " "),
            _c("i", { staticClass: "fa fa-chevron-right" }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }